null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/japgolly/scalajs-react/v1.7.0/extra/src/main/scala/japgolly/scalajs/react/extra/router/RouteCmd.scala